import { createChatBotMessage } from 'react-chatbot-kit'
const Config = {
initialMessages:[createChatBotMessage('Hello! How can I help you today?')],
botName:"FitMatchBot"
}

export default Config